module.exports = __webpack_public_path__ + "img/768.612b2fc5.gif";